import { render, staticRenderFns } from "./reportExpert.vue?vue&type=template&id=60f42e48&"
import script from "./reportExpert.vue?vue&type=script&lang=js&"
export * from "./reportExpert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports